import { Add, Delete } from '@mui/icons-material';
import { IconButton } from 'bso-ui';
import DeleteConfirmationDialog from 'components/DeleteConfirmationDialog/DeleteConfirmationDialog';
import { isAppAdmin } from 'helpers/permissions';
import React from 'react';
import { Tooltip } from '@mui/material';
import InterfaceConfigurationCreate from './Form/InterfaceConfigurationCreate';

const ConfigureActionButtons = ({
  type, item = null, compression, refetch, handleDelete, userData
}) => {
  if (!userData || (!userData.is_staff && !isAppAdmin(userData.groups))) {
    return <div style={{ paddingTop: '36px' }} />;
  }
  if (item) {
    return (
      <DeleteConfirmationDialog
        title={`Delete ${type}`}
        contentText={`Are you sure you want to delete this ${type}?`}
        confirmText="Yes"
      >
        {(confirm) => (
          <Tooltip title={`Delete ${type}`}>
            <div>
              <IconButton
                size="small"
                color="primary"
                bgTransparent
                        // disabled={isFetching}
                style={{
                  maxWidth: '20px', maxHeight: '20px', minWidth: '20px', minHeight: '20px'
                }}
                onClick={confirm(() => handleDelete(item))}
              >
                <Delete />
              </IconButton>
            </div>
          </Tooltip>
        )}
      </DeleteConfirmationDialog>
    );
  }

  return (
    <InterfaceConfigurationCreate
      title={`add ${type}`}
      iconButton={{
        content: <Add />,
        color: 'primary',
        size: 'small',
        customSize: true
        // disabled: isFetching
      }}
      button={{
        content: 'Add',
        color: 'primary',
        variant: 'standard',
        state: 'outlined',
        customSize: true
      }}
      data={{ type }}
      refetch={refetch}
      prefilledId={compression.length + 1}
    />
  );
};

export default ConfigureActionButtons;
